import React from 'react';
import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { CtaContentCard } from '@ahc-digital/component-library';
import { CreateCTAContentCardModel } from './C20CTAContentCards.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C20CTAContentCardProps = RenderingProps<
  C20CTAContentCardFields,
  {
    TitleType?: string;
    FirstCTAStyle?: string;
    SecondCTAStyle?: string;
    CTAAlignment?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams &
    ImagePropertiesParams
>;

export type C20CTAContentCardFields = {
  Headline?: Field<string>;
  BodyCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  ThirdCTA?: LinkField;
  CardImage?: ImageField;
};

export const Default = (props?: C20CTAContentCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <CtaContentCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateCTAContentCardModel(props)}
    />
  );
};
